import React, { useState, useEffect } from "react";
import { Card, Button, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getUserPrograms } from '../services/ProgramApi';
import { toast } from 'react-toastify';
import LoadingSpinner from './LoadingSpinner';
import config from '../config/config';
import moment from "moment";
import { formatDate } from '../utils/dateUtils';

const ProgramTimeline = () => {
  const navigate = useNavigate();
  const [userPrograms, setUserPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserPrograms = async () => {
      try {
        const response = await getUserPrograms();
        if (response.data && Array.isArray(response.data)) {
          setUserPrograms(response.data);
        } else {
          setUserPrograms([]);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to fetch programs");
      } finally {
        setLoading(false);
      }
    };
    fetchUserPrograms();
  }, []);

  const calculateDaysLeft = (endDate) => {
    const current = moment();
    const end = moment(endDate);
    return end.diff(current, 'days');
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="timeline-container">
      {userPrograms.map((data, index) => {
        const daysLeft = data.subscriptions?.end_date ? calculateDaysLeft(data.subscriptions.end_date) : null;
        const isExpired = daysLeft !== null && daysLeft < 0;
        const isExpiringSoon = daysLeft !== null && daysLeft >= 0 && daysLeft <= 10;

        return (
          <div className="timeline-item" key={index}>
            <div className="timeline-dot"></div>
            <div className="timeline-line"></div>
            <Card className="timeline-card">
              <Card.Body className='p-2'>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="fw-6 fs-18 text-white">{data.child?.child_name}</h4>
                  <img src={`${config.Image_Base_URL}${data.child?.profile_pic_url}`} alt="Profile" className="profile-img" />
                </div>
                <p className="text-white mb-1 fs-10 d-flex justify-content-between">
                  <span><span>Course:</span> {data.sub_program_focus?.title} {data.sub_program_focus?.title && `in`} {data.program?.program_name} &nbsp;</span>
                  <span><span>Skill Level:</span> {data.skill_level?.skill_name}</span>
                </p>
                <p className="text-white mb-1">
                  <span>
                    {data.time_slots.map((slot, idx) => (
                      <h6 key={idx} className='fs-10 mb-1'>
                        <span className='fw-7'>Slot-{idx + 1}: </span>
                        <span>{slot.start_time} - {slot.end_time}, {["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][slot.day]}</span>
                      </h6>
                    ))}</span>
                </p>
                <p className="text-white mb-1 fs-10">
                  <span>Subscription: </span>
                  <strong className="text-capitalize">{data.subscriptions?.status}</strong>
                  {isExpired && <Badge bg="danger" className="ms-2">Expired</Badge>}
                  {isExpiringSoon && <Badge bg="warning" text="dark" className="ms-2">{daysLeft} days left</Badge>}
                </p>
                <p className="text-white mb-1 fs-10">
                  {!isExpired && <span>End Date: {formatDate(data.subscriptions?.end_date)}</span>}
                </p>
                {data.subscriptions.status === "expired" && (
                  <p className="text-white fs-10">Upgrade to the next level with The Pied Piper!</p>
                )}
                <div className="d-flex justify-content-between">
                  {(data.subscriptions.status === "expired" || isExpiringSoon) && (
                    <Button variant="info" size='sm' onClick={() => navigate(`/pickList/${data.program.id}`, { state: { renewalData: data } })} className="fw-6 fs-10 text-white border-black border-2">
                      Recharge Now
                    </Button>
                  )}
                  <div className="ms-auto">
                    <Button variant="warning" onClick={() => navigate(`/progressReport/${data.child?.id}`)} size='sm' className="fw-6 fs-10 text-white  border-black border-2">
                      View Progress
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        );
      })}
    </div>
  );
};

export default ProgramTimeline;

